export const formatData = data => {
  const result = {}
  data.map(project => {
    const projects = result[project.owner.id] || []
    result[project.owner.id] = [...projects, project]
  })
  return result
}
